import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';

const steps = [
  { num: '01', title: 'Sync', desc: 'Connect Rekordbox databases or scan folders, then keep your library state in one place.', accent: 'accent' },
  { num: '02', title: 'Build', desc: 'Use Quick Tag, PathFlo, JourneyFlo, and Analytics to prep better sets faster.', accent: 'green' },
  { num: '03', title: 'Ship', desc: 'Export updates, benchmark performance, and let Watch Folder automation keep new tracks in sync.', accent: 'cyan' },
];

export default function HowItWorks() {
  const ref = useRef(null);
  const v = useInView(ref, { once: true, margin: '-80px' });

  return (
    <section id="how-it-works" data-testid="how-it-works-section" ref={ref} className="section">
      <div className="container">
        <motion.div
          className="section-header"
          initial={{ opacity: 0, y: 30 }}
          animate={v ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
        >
          <span className="eyebrow">How It Works</span>
          <h2 data-testid="how-it-works-title" className="section-title">From library mess to set-ready</h2>
        </motion.div>

        <div className="steps-grid">
          {steps.map((s, i) => (
            <motion.div
              key={s.num}
              data-testid={`step-${i}`}
              initial={{ opacity: 0, y: 30 }}
              animate={v ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.7, delay: 0.15 + i * 0.1 }}
            >
              <div className="step-num">{s.num}</div>
              <div className="step-line-track">
                <div className={`step-line-fill step-line-fill--${s.accent}`} />
              </div>
              <h3 className="step-title">{s.title}</h3>
              <p className="text-muted">{s.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
